/* eslint-disable @typescript-eslint/ban-ts-comment */
import { parseBool } from '@seiri/shared/common'

export interface Environment {
  name: string
  production: boolean
  apiPrefix: string
  apiHost: string
  clientHost: string
  sentry: boolean
  sentryDsn: string
  buildCommit: string
  buildCommitTime: string | null

  demoRelease: boolean
  prodRelease: boolean

  /** This environment's seiri-elements loader on the CDN, for the embed snippet. See docs/embed-releases.md. */
  embedScriptUrl: string
}

export const environment: Environment = {
  //@ts-ignore
  name: process.env['APP_ENV_NAME'] || 'development',
  //@ts-ignore
  production: parseBool(process.env['APP_PRODUCTION']),
  //@ts-ignore
  apiPrefix: process.env['APP_API_PREFIX'] ?? process.env['WEB_API_PREFIX'] ?? '',
  //@ts-ignore
  apiHost: process.env['WEB_API_HOST'] ?? '',
  //@ts-ignore
  clientHost: process.env['APP_CLIENT_HOST'] || '',
  //@ts-ignore
  sentry: parseBool(process.env['WEB_SENTRY']),
  //@ts-ignore
  sentryDsn: process.env['WEB_SENTRY_DSN'] || '',
  //@ts-ignore
  buildCommit: process.env['APP_BUILD_VERSION'] || 'local',
  //@ts-ignore
  buildCommitTime: process.env['APP_BUILD_TIME'] || null,
  //@ts-ignore
  demoRelease: parseBool(process.env['WEB_DEMO_RELEASE']),
  //@ts-ignore
  prodRelease: parseBool(process.env['WEB_PROD_RELEASE']),
  //@ts-ignore
  embedScriptUrl: process.env['WEB_EMBED_SCRIPT_URL'] || 'https://cdn.seiri.io/embed/demo/seiri-elements.js',
}
